// extracted by mini-css-extract-plugin
export default {"title":"NFCSMintExitConfirm_title__tVUTS","subtitle":"NFCSMintExitConfirm_subtitle__6gbS-","stayBtn":"NFCSMintExitConfirm_stayBtn__1mMk-"};